export default __webpack_public_path__ + "static/media/ampersand.9313296f.svg";